// libs
import { styled } from '@nykaa/ui-components';

export const APluContainer = styled.section`
  cursor: pointer;

  .APlusContent-banner,
  .APlusContent-banner-container {
    width: 100%;
  }
  border-bottom: solid 1px ${({ theme }) => theme.colors.textOutline};
`;

export const ViewMoreInfoCTA = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: ${({ theme }) => theme.spacing.spacing60};
  margin-bottom: ${({ theme }) => theme.spacing.spacing60};
`;

export const ViewMoreInfoText = styled.div`
  height: 20px;
  display: flex;
  align-items: center;
  ${({ theme }) => theme.typography.subTitleLarge}
  color: ${({ theme }) => theme.colors.secondary};
`;

export const ViewMoreIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ theme }) => `margin-left: ${theme.spacing.spacing40}`};
`;
